export default {
    rule: 'Event Rules',
    text1: 'Portfolio Earnings Ranking',
    text2: 'Learn More',
    text3: 'HK Stocks',
    text4: 'US Stocks',
    text5: 'Funds',
    text6: 'Portfolio Age',
    text7: 'Cumulative ROI',
    text8: 'Daily Change',
    text9: 'View Full Ranking',
    text10: 'Disclaimer',
    text11: 'Offers subject to terms, not combinable with other promotions. Provided by Fosun Wealth Intl Securities Ltd. Fosun Wealth reserves the right to modify or cancel offers without notice. Fosun Wealth has final say in disputes. This ad does not constitute an offer, solicitation, recommendation, or guarantee of any security, financial product, or instrument. Content not reviewed by SFC. Investing involves risks. Prices may rise or fall. Understand risks before investing. Consult professionals if needed.',
    text12: 'Claimed Successfully',
    text13: 'Use Now',
    text14: 'Reminder',
    text15: 'Thanks for your support. Event limited to specific channels & non-trading portfolio clients.',
    text16: 'View More Portfolios',
    text17: 'Limited Time: Claim HKD 500 Commission-Free Voucher',
    text18: 'Event Ended',
    text19: 'Claim Failed. Retry Later.',
    text20: 'Strategy Insights:',
    text21: 'Limited Time: Claim Commission-Free Voucher',
    text22: 'Claim Voucher for Commission-Free Trades',
    text23: 'Portfolio, your investment tool. Claim HKD 500 commission-free voucher now.',
    text24: 'Login to View Details',
    text25: 'Login to Claim Voucher',
    text26: 'Event Period',
    text27: 'Same market voucher in use. Check voucher center for details.',
    text28: 'Login Now',
    text29: 'Open Account Now',
    text30: 'Unknown Error',
    text31: 'Thanks for your support. Event limited to specific channel clients.',
    phonePlaceholder: 'Enter Mobile Number',
    codePlaceholder: 'Enter Verification Code',
    readText: 'I have read and agreed to',
    userRule: 'User Agreement,',
    privateRule: 'Privacy Policy',
    captureText1: 'Get Code',
    captureText2: 'Retry in {s} seconds',
    captureText3: 'Retry',
    agreeRule: 'Agree to Terms',
    errorText1: 'Invalid Code. Retry.',
    label1: 'Name',
    label2: 'Phone',
    label3: 'Email',
    label4: 'Appointment Time',
    label5: 'Departure City',
    label6: 'Age',
    label7: 'Gender',
    placeholder1: 'Enter Name',
    placeholder2: 'Enter Phone',
    placeholder3: 'Enter Email (Optional)',
    placeholder4: 'Select Time',
    placeholder5: 'Enter Departure City',
    placeholder6: 'Select Age',
    btn: 'Submit',
    ym: '{y}/{m}',
    closeText: 'Close',
    cydq: 'Common Regions',
    openText1: 'Account opened. Learn more in App.',
    openText2: 'Open Account',
    openBtnText1: 'Download App',
    openBtnText2: 'Open Account',
    downloadApp: 'Go to App',
    openText3: 'Continue Opening Account to Claim Benefits',
    validatorText: 'No need to resend within 60s',
    enterCorrectEmail: 'Enter Valid Email',
    boy: 'Male',
    girl: 'Female',
    had: 'Yes',
    no: 'No',
    pageTitle: 'Fosun Wealth Account Opening',
    ycj: 'You have participated in similar events. No re-entry.',
    iknow: 'Got it',
    firstk: 'Claim after first portfolio trade.',
}
